import { IArkiveringStatusState } from './types'

export const arkiveringStatusActionsTypes = {
  FETCH: 'arkivering-status/FETCH_ARKIVERING_STATUS' as const,
  FETCH_SUCCESS: 'arkivering-status/FETCH_ARKIVERING_STATUS_SUCCESS' as const,
  FETCH_FAILED: 'arkivering-status/FETCH_ARKIVERING_STATUS_FAILED' as const,
}

export const arkiveringStatusActions = {
  fetch: (aar: string, sekvensnummer: string, hoveddokumentId: string) => ({
    type: arkiveringStatusActionsTypes.FETCH,
    aar,
    sekvensnummer,
    hoveddokumentId,
  }),

  fetchSuccess: (data: IArkiveringStatusState['data']) => ({
    type: arkiveringStatusActionsTypes.FETCH_SUCCESS,
    data,
  }),

  fetchFailed: (error: string) => ({
    type: arkiveringStatusActionsTypes.FETCH_FAILED,
    error,
  }),
}
